import React from "react";

/** Decorative hamburger / close bars — parent supplies the button. */
const HamburgerIcon = ({ isOpen = false }) => {
  return (
    <span
      className={`relative block w-5 h-5 ${isOpen ? "open" : ""}`}
      aria-hidden='true'>
      <span
        className={`absolute left-0 w-full h-0.5 rounded-lg bg-current block transition-all duration-200 ${
          isOpen ? "top-2.5 rotate-45" : "top-1"
        }`}
      />
      <span
        className={`absolute left-0 top-2.5 w-full h-0.5 rounded-lg bg-current block transition-all duration-200 ${
          isOpen ? "scale-0 opacity-0" : "opacity-100"
        }`}
      />
      <span
        className={`absolute left-0 w-full h-0.5 rounded-lg bg-current block transition-all duration-200 ${
          isOpen ? "top-2.5 -rotate-45" : "top-4"
        }`}
      />
    </span>
  );
};

export default HamburgerIcon;
